var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiCodeCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7895 21.8182H8.63158V6.54545H20.7895M20.7895 4.36364H8.63158C8.04531 4.36364 7.48305 4.59351 7.0685 5.00268C6.65395 5.41185 6.42105 5.9668 6.42105 6.54545V21.8182C6.42105 22.3968 6.65395 22.9518 7.0685 23.361C7.48305 23.7701 8.04531 24 8.63158 24H20.7895C21.3757 24 21.938 23.7701 22.3526 23.361C22.7671 22.9518 23 22.3968 23 21.8182V6.54545C23 5.9668 22.7671 5.41185 22.3526 5.00268C21.938 4.59351 21.3757 4.36364 20.7895 4.36364ZM17.4737 0H4.21053C3.62426 0 3.062 0.22987 2.64745 0.63904C2.23289 1.04821 2 1.60316 2 2.18182V17.4545H4.21053V2.18182H17.4737V0Z",
    fill: "#011367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCodeCopy);
export default __webpack_public_path__ + "static/media/ai-code-copy.67d20b42cb8e7c1cf92d6d4aa3eb87a7.svg";
export { ForwardRef as ReactComponent };